import {Component, ElementRef, ViewChild} from '@angular/core';
import {Renderer2} from '@angular/core';
import {CommandResolver} from '../commands/command-resolver';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/do';


declare var window;

@Component({
  selector: 'command-line',
  templateUrl: 'command-line.html'
})
export class CommandLineComponent {


  rejectionPhrases = ["no", "nope", "won't happen", "don't know this one", "ouch"];

  text: string;
  textInput: string;
  mode = "normal"; //TODO: determine how command should be parsed, support JS or other modes


  @ViewChild('divArea') divArea: ElementRef;
  @ViewChild('speechBubbleContent') speechBubbleContent: ElementRef;
  @ViewChild('speechBubbleContainer') speechBubbleContainer: ElementRef;


  keys$;

  public commandResolver: CommandResolver;

  constructor(public elementRef: ElementRef,
              private renderer: Renderer2,) {
    console.log('Hello CommandLineComponent Component');
    this.text = 'Hello World';

    // this.eventEmitter.subscribe("commandExecuted", function)
  }

  ngAfterViewInit() {

    this.keys$ = Observable.fromEvent(this.divArea.nativeElement, 'keyup').do(() => {
      //TODO: look for supported commands?
      console.log("observable", this.divArea.nativeElement.innerText.trim());
    });
    // this.keys$.subscribe();

    setTimeout(() => {
      console.log("timeout!")
      this.divArea.nativeElement.focus();
    }, 1200);


  }

  setMode(mode) {
    this.mode = mode;
  }

  keydown(event) {
    //if it is arrow up or arrow down do something
    switch (event.keyCode) {
      case 38:
        //up
        event.preventDefault();
        // TODO: cycle through command history
        break;
      case 40:
        //down
        event.preventDefault();
        break;
    }
  }


  say(what, howlong) {

    this.speechBubbleContent.nativeElement.innerHTML = what;
    this.showBubbleContainer();

    if (howlong) {
      setTimeout(() => {

        this.hideBubbleContainer()
      }, howlong)
    }
    else {
      //enable closing button

    }
  }

  speak(what) {
    let phrase = new SpeechSynthesisUtterance(what);
    phrase.voice = window.speechSynthesis.getVoices()[11];
    window.speechSynthesis.speak(phrase);
  }

  speakAndSay(what, howlong) {
    this.say(what, howlong);
    this.speak(what);
  }


  keypress(event) {
    // debugger;
    if (event.keyCode == 13) {
      if (event.shiftKey) {
        //TODO: shift+return was pressed, do something different
      }
      else {

        let commandString = this.divArea.nativeElement.innerText.trim();

        // if(cmdObj[0].command=="say")
        // {
        //
        //   this.speakAndSay(cmdObj[0].commandString.split("say")[1], 2000);
        //   // this.renderer.setProperty(this.divArea.nativeElement, 'innerText','');
        //
        //   this.renderer.setProperty(this.divArea.nativeElement, 'innerHTML', '')
        //
        //
        //   // this.divArea.nativeElement.innerText="";
        //   return false;
        // }


        //return was pressed, parse command and execute it
        // console.log("cmdObj is ", cmdObj);


        this.elementRef.nativeElement.dispatchEvent(new CustomEvent('commandIssued', {detail: commandString, bubbles: true}))
        return false;

      }
    }
  }

  clear() {
    this.renderer.setProperty(this.divArea.nativeElement, 'innerHTML', '')
  }

  hideBubbleContainer() {
    this.renderer.setStyle(this.speechBubbleContainer.nativeElement, 'opacity', '0');
    setTimeout(() => {
      this.renderer.setStyle(this.speechBubbleContainer.nativeElement, 'display', 'none');
    }, 600);
  }

  showBubbleContainer() {
    this.renderer.setStyle(this.speechBubbleContainer.nativeElement, 'display', 'block');
    this.renderer.setStyle(this.speechBubbleContainer.nativeElement, 'opacity', '1');
  }

}




// WEBPACK FOOTER //
// ./src/components/command-line/command-line.ts